module.exports = __webpack_public_path__ + "static/media/8OLA2.87396674.jpg";